<template>
  <div>
  <app-header
      @on-click="goBack"
  ></app-header>
         <van-row class="top">
          <van-col span="10" offset=10 dir="ltr">
            <img class="img" src="../../../assets/imgs/success-icon.png" />
          </van-col>
          <van-col class="center" >
            <div class="title">{{$t('PromotionCode.recharge_success.content')}}</div>
          </van-col>
         </van-row>
      <div>
        <van-cell-group>
                <van-cell class="content" :title="$t('PromotionCode.recharge_success.package')"  arrow-direction="down" :value="values" />
        </van-cell-group>
      </div>
    <div class="top">
         <van-row>
          <van-col span="23" offset=2 dir="ltr">
            <van-button @click="btnDetails()" round class="btn1" v-if="Module_MyFlow">{{$t('PromotionCode.recharge_success.view_packets')}}</van-button>
            <van-button @click="btnback()" plain round  class="btn2">{{$t('PromotionCode.recharge_success.back')}}</van-button>
          </van-col>
         </van-row>
    </div>
  </div>
</template>

<script>
import {Row,Col} from "vant";
import checkProjectConfig from '@/lib/checkProjectConfig';

export default {
  components:{
  vanRow:Row,
  vanCol: Col, 
  },
name: 'RechargeSuccess',
  data(){
     return{
      values:this.$route.query.goods,
    }
  },
   computed: {
        Module_MyFlow:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_MyFlow",true);
        }
    },
methods:{
    goBack() {
       this.$router.go(-1);
    },
    btnback(){
    this.$router.push({
        path: '/'
     })
    },
    btnDetails(){
    this.$router.push({
        name: 'OrderList'
    }); 
},
 }
}
</script>

<style scoped>

.btn1{
  width: 91%;
  height: 40px;
  font-family: PingFangSC-Medium;
  background: #6BBC46;
  border-radius: 100px;
  border-radius: 24px;
  color: #fff;
}

.btn2{
  width: 91%;
  height: 40px;
  margin-top: 15px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #6BBC46;
  border-color: #6BBC46;
  letter-spacing: 0;
  text-align: center;
  line-height: 16px;
}

.title{
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #333333;
  letter-spacing: 0;
  font-weight:900;
  margin-top: 10px;
}
.content{
  margin-top: 50px;
  
}
.img {
width: 60px;
}
.top{
  margin-top: 50px;
}
.center {
  width: 100%;
  text-align: center;
}
</style>